export default __webpack_public_path__ + "4f6c036b3ab730ada0fda04b48cb5539.png";